import * as angular from 'angular';
import * as _ from 'underscore';
import { IImgFileModel, IImgFilereaderModel } from './models';

function imgFileReader($q: ng.IQService, $timeout: ng.ITimeoutService, $translate: angular.translate.ITranslateService) {
    const slice = Array.prototype.slice;

    return {
        restrict: 'A',
        require: '?ngModel',
        scope: {
            callback: '&',
            maxSizeMb: '=?',
            minHeight: '=?',
            minWidth: '=?',
            fileExtensions: '<',
            fileOnly: '<'
        },
        link(scope: ng.IScope & IImgFilereaderModel, element: JQLite, attrs: ng.IAttributes, ngModel: ng.INgModelController) {
            if (!ngModel) {
                return;
            }
            const mb = 1000000;
            const maxSizeMb = scope.maxSizeMb ? scope.maxSizeMb : 5;
            const maxSize = maxSizeMb * mb;
            const minHeight = (scope.minHeight && scope.minWidth) ? scope.minHeight : 120;
            const minWidth = (scope.minHeight && scope.minWidth) ? scope.minWidth : 120;
            const fileExtensions = scope.fileExtensions ? scope.fileExtensions : [];
            const fileOnly = scope.fileOnly;

            ngModel.$render = () => { return; };

            element.bind('change', (jQueryEvent: JQueryEventObject) => {
                const target = jQueryEvent.target as HTMLInputElement;

                function readFile(file: File & IImgFileModel) {
                    const deferred = $q.defer<File>();

                    const reader = new FileReader();

                    if (fileExtensions && fileExtensions.length > 0) {
                        const fileExt = file.name.split('.').pop();
                        if (!fileExt || !fileExtensions.find((ext) => ext.toLowerCase() === fileExt.toLowerCase())) {

                            file.error = $translate.instant('image_unsupported_format', { formats: fileExtensions.join(', ').toUpperCase() });
                            deferred.resolve(file);
                            target.value = null;
                            return deferred.promise;
                        }
                    }

                    if (file.size > maxSize) {
                        file.error = $translate.instant('file_size_too_big', { maxSizeMb });
                        deferred.resolve(file);
                        target.value = null;

                        return deferred.promise;
                    }

                    reader.onload = (e: Event) => {
                        if (fileOnly) {
                            file.dataUri = reader.result;
                            deferred.resolve(file);
                            target.value = null;
                        } else {
                            const img = new Image();
                            img.onload = () => {
                                if (img.width < minWidth || img.height < minHeight) {
                                    file.error = $translate.instant('image_too_small', { minWidth, minHeight });
                                } else {
                                    file.dataUri = reader.result;
                                    file.imageSize = {
                                        width: img.width,
                                        height: img.height
                                    };
                                }
                                deferred.resolve(file);
                                target.value = null;
                            };
                            img.src = reader.result;
                        }

                    };

                    reader.onerror = (e: Event) => {
                        deferred.reject(e);
                    };

                    reader.readAsDataURL(file);

                    return deferred.promise;
                }

                const files: File[] = slice.call(target.files, 0);
                $q.all(files.map(readFile))
                    .then((values: File[]) => {
                        if (target.multiple) {
                            ngModel.$setViewValue(values.length ? values : []);
                        } else {
                            ngModel.$setViewValue(values.length ? values[0] : null);
                        }

                        if (_.isFunction(scope.callback)) {
                            $timeout(scope.callback);
                        }
                    });
            }); // change
        } // link
    }; // return
}

angular
    .module('app.common')
    .directive('imgFilereader', imgFileReader);

imgFileReader.$inject = ['$q', '$timeout', '$translate'];



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/directives/img-filereader.directive.ts